// project import
import Navigation from './navigation';
import SimpleBar from '../../../../components/third-party/simpleBar';

// ==============================|| DRAWER CONTENT ||============================== //

const DrawerContent = () => {
	return (
			<Navigation/>
	);
};

export default DrawerContent;
